import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/list/vertical-pop.svg'
import _imports_1 from '@/assets/images/list/epoch-lower-left.svg'
import _imports_2 from '@/assets/images/list/epoch-upper-right.svg'
import _imports_3 from '@/assets/images/epoch.svg'
import _imports_4 from '@/assets/images/calendar.svg'
import _imports_5 from '@/assets/images/list/clock-epoch.svg'


const _withScopeId = n => (_pushScopeId("data-v-3df04cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-card-epoch__arrow-top bg-light" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "block-card-epoch__design-element block-card-epoch__design-element--vertical-pop",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "block-card-epoch__design-element block-card-epoch__design-element--lower-left",
  src: _imports_1
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "block-card-epoch__design-element block-card-epoch__design-element--upper-right",
  src: _imports_2
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary block-card-epoch__icon mr-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_6 = { class: "block-card-epoch__subtitle mr-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary block-card-epoch__icon mr-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_8 = { class: "block-card-epoch__subtitle mr-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary block-card-epoch__icon mr-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_10 = { class: "block-card-epoch__subtitle mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_row = _resolveComponent("a-row")!
  const _component_BlockCardLayoutBoxedItem = _resolveComponent("BlockCardLayoutBoxedItem")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_BlockCardLayout = _resolveComponent("BlockCardLayout")!

  return (_openBlock(), _createBlock(_component_BlockCardLayout, { class: "block-card-epoch" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_row, {
        gutter: 0,
        justify: "space-between",
        wrap: ""
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { align: "middle" }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("Epoch")) + " " + _toDisplayString(_ctx.itemDetails.epochNo), 1),
                      _createElementVNode("div", null, "(" + _toDisplayString(_ctx.currentRoadmap(_ctx.itemDetails.epochNo)) + ")", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { align: "middle" }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("Ended at")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.itemDetails.endTimestamp)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { align: "middle" }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("Ended at")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formatTime(_ctx.itemDetails.endTimestamp)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("blocks")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("blocks")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.blocksCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("transactions")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("transactions")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.transactionsCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("transactions amount")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("transactions amount")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.transactionsAmount,
                        unit: "₳"
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("transactions fee")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("transactions fee")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.transactionsFee,
                        unit: "₳"
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pools")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("pools")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.poolsCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pools with block")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("pools with block")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.poolsWithBlocksCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pools with stake")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("pools with stake")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.poolsWithStakeCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("delegation")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("delegation")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.delegationAmount,
                        unit: "₳"
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        unit: "₳",
                        amount: _ctx.itemDetails.rewardsAmount
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pool fee")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("pool fee")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        unit: "₳",
                        amount: _ctx.itemDetails.poolsFee
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("accounts")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("accounts")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.accountsCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("delegators")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("delegators")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.delegatorsCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_BlockCardLayoutBoxedItem, null, {
                "inline-label": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_AmountText, {
                        amount: _ctx.itemDetails.rewardsCount,
                        minPrecision: 0
                      }, null, 8, ["amount"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}